import React from "react";

export default class AssessmentCheckupSuccess extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var overall = this.getResultItem("FINANCIAL_FITNESS");
    if (overall) {
      return (
        <div className="AssessmentCheckupSuccess">
          <h1>Your Financial Fitness Score&trade;</h1>
          {this.renderGraph()}
          {this.renderResults()}
          <h2>What does this score mean?</h2>
          {this.renderScoreExplanationText(overall.score.scaled)}
          {this.props.hideButtons === true ? (
            ""
          ) : (
            <div className="btn-wrapper">
              <button
                type="button"
                className="btn btn-large btn-primary"
                onClick={this.props.onHide}
              >
                Start Your Journey to <strong>Financial Wellness</strong>
              </button>
            </div>
          )}
        </div>
      );
    } else {
      return null;
    }
  }

  renderGraph() {
    var overall = this.getResultItem("FINANCIAL_FITNESS");
    return (
      <div className="Graph">
        <div className="OverallScore">{overall.score.scaled}</div>
        <div className="OutOf">out of {overall.score.scaledMax}</div>
        <div
          className="PositionCircle"
          style={this.getPositionCirclePosition(overall.score.scaled)}
        />
        <div className="high-stress">High Stress</div>
        <div className="low-stress">Low Stress</div>
        <svg
          width="253"
          height="133"
          viewBox="0 0 253 133"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 126.802C6 77.0603 46.4907 6.59277 126.092 6.59277C205.693 6.59277 246.183 77.0603 246.183 126.802"
            stroke="url(#paint0_linear)"
            strokeWidth="12"
            strokeLinecap="round"
          />
          <defs>
            <linearGradient
              id="paint0_linear"
              x1="220.134"
              y1="126.899"
              x2="23.8813"
              y2="126.899"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#84D296" />
              <stop offset="0.458333" stopColor="#FFEA9E" />
              <stop offset="1" stopColor="#F85E5E" />
            </linearGradient>
          </defs>
        </svg>
      </div>
    );
  }

  renderResults() {
    var results = [];
    var result_objects = {};
    result_objects["CONFIDENCE"] = this.getResultItem("CONFIDENCE");
    result_objects["BEHAVIOR"] = this.getResultItem("BEHAVIOR");
    result_objects["APTITUDE"] = this.getResultItem("APTITUDE");

    for (var i in result_objects) {
      var result = result_objects[i];
      if (result) {
        results.push(
          <div className="score-card" key={i}>
            <div className="name">{i.toLowerCase()}</div>
            <div className="score">{result.score.scaled}</div>
            <div className="out-of">out of {result.score.scaledMax}</div>
          </div>
        );
      }
    }

    return <div className="score-cards">{results}</div>;
  }

  renderScoreExplanationText(score) {
    if (score < 6) {
      return (
        <p>
          <strong>THERE IS GOOD NEWS!</strong> Improving your financial fitness
          does not need to be difficult. In fact, small, daily changes can add
          up to thousands of dollars over time. You can take control of your
          financial future today!
        </p>
      );
    } else if (score >= 6 && score < 8) {
      return (
        <p>
          <strong>YOU'RE DOING GREAT!</strong> There are still many steps you
          can take to improve your financial fitness. In fact, small, daily
          changes can add up to thousands of dollars over time. You can make an
          impact on your financial future today!
        </p>
      );
    } else if (score >= 8) {
      return (
        <p>
          <strong>CONGRATULATIONS!</strong> There are still many steps you can
          take to build an even stronger foundation for financial security but
          you are starting off well.
        </p>
      );
    }
  }

  /**
   * Helper functions
   */

  getPositionCirclePosition(value) {
    if (value === 0) {
      return { top: 112, left: -5 };
    } else if (value > 0 && value < 1) {
      return { top: 90, left: -2 };
    } else if (value >= 1 && value < 2) {
      return { top: 78, left: 2 };
    } else if (value >= 2 && value < 3) {
      return { top: 60, left: 10 };
    } else if (value >= 3 && value < 4) {
      return { top: 40, left: 23 };
    } else if (value >= 4 && value < 5) {
      return { top: 4, left: 70 };
    } else if (value === 5) {
      return { top: -4, left: 116 };
    } else if (value > 5 && value < 6) {
      return { top: 2, left: 155 };
    } else if (value >= 6 && value < 7) {
      return { top: 12, left: 176 };
    } else if (value >= 7 && value < 8) {
      return { top: 42, left: 210 };
    } else if (value >= 8 && value < 9) {
      return { top: 68, left: 225 };
    } else if (value >= 9 && value < 10) {
      return { top: 94, left: 233 };
    } else if (value === 10) {
      return { top: 113, left: 235 };
    }
  }

  getResultItem(key) {
    var { results } = this.props;
    for (var i in results) {
      var result = results[i];
      if (result && result.type === key) {
        return result;
      }
    }
  }
}
